import { hsl } from 'polished';
export default {
    global: {
        black: '#262626',
        white: '#fff',
    },
    // Primary = orange
    orange: {
        base: '#EE724D',
        _100: '#FCE3DB',
        _200: '#F8C7B8',
        _300: '#F5AA94',
        _400: '#F18E71',
        _500: '#EB582C',
        _600: '#DD4315',
        _700: '#BC3912',
        _800: '#9B2F0F',
        _900: '#7A250C',
        _1000: '#591B09',
    },
    orangeAccessible: {
        base: '#C7502D',
        _800: '#9F4024',
        _900: '#77301B',
        _1000: '#502012',
    },
    // Secondary = red
    red: {
        base: '#C81436',
        _100: '#FBD9E0',
        _200: '#F7B4C0',
        _300: '#F48EA1',
        _400: '#F06882',
        _500: '#EC4363',
        _600: '#E81D43',
        _700: '#AB112E',
        _800: '#8D0E26',
        _900: '#700B1E',
        _1000: '#520816',
    },
    // Tertiary = teal
    teal: {
        base: '#0894A9',
        _100: '#D7F8FD',
        _200: '#B0F1FB',
        _300: '#88EBF9',
        _400: '#60E4F7',
        _500: '#38DDF6',
        _600: '#11D6F4',
        _700: '#0AB7D1',
        _800: '#077B8C',
        _900: '#05616F',
        _1000: '#044852',
    },
    tealAccessibleDark: {
        base: '#0A8092',
        _100: '#086C7C',
        _200: '#086270',
        _300: '#075965',
        _400: '#064F5A',
        _500: '#05454F',
        _600: '#053B43',
        _700: '#043138',
        _800: '#03272D',
        _900: '#04333A',
        _1000: '#021416',
    },
    tealAccessibleLight: {
        base: '#1C9DB0',
        _100: '#CBE8ED',
        _200: '#B9E1E7',
        _300: '#A8D9E1',
        _400: '#96D2DB',
        _500: '#85CAD4',
        _600: '#73C3CE',
        _700: '#62BBC8',
        _800: '#50B4C2',
        _900: '#3FACBC',
        _1000: '#2DA5B6',
    },
    neutrals: {
        base: '#fff',
        _100: '#E9E9E9',
        _200: '#D3D2D2',
        _300: '#BDBBBB',
        _400: '#A8A5A5',
        _500: '#928D8D',
        _600: '#7D7676',
        _700: '#666060',
        _800: '#504B4B',
        _900: '#393535',
        _1000: '#221F1F',
    },
    blacks: {
        base: '#131313',
        _100: '#EAEAEA',
        _200: '#D4D4D4',
        _300: '#BFBFBF',
        _400: '#A9A9A9',
        _500: '#949494',
        _600: '#7E7E7E',
        _700: '#696969',
        _800: '#535353',
        _900: '#3E3E3E',
        _1000: '#262626',
    },
    lightGreys: {
        base: '#EAECEC',
        _100: '#F5F6F6',
        _200: '#BBC2C2',
        _300: '#8D9898',
        _400: '#616B6B',
    },
    darkGreys: {
        base: '#868586',
        _100: '#D7D6D7',
        _200: '#AEAEAE',
        _300: '#686768',
        _400: '#494949',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #333333 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #555555 */
        grey33: hsl(0, 0, 0.33),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F6F6F6 */
        grey96: hsl(0, 0, 0.96),
    },
    validation: {
        error: {
            base: '#B02E2E',
            _100: '#EDBABA',
            _200: '#DB7575',
            _300: '#8A2424',
        },
        success: {
            base: '#55AA63',
            _100: '#C6E3CB',
            _200: '#8EC697',
            _300: '#3B7745',
        },
        warning: {
            base: '#E18C23',
            _100: '#F5D9B6',
            _200: '#EBB26C',
            _300: '#A06216',
        },
    },
};
